__turbopack_context__.v({
  "backgroundRing": "spinner-module-scss-module__--vZkW__backgroundRing",
  "circle": "spinner-module-scss-module__--vZkW__circle",
  "circleMulti": "spinner-module-scss-module__--vZkW__circleMulti",
  "dash": "spinner-module-scss-module__--vZkW__dash",
  "inner": "spinner-module-scss-module__--vZkW__inner",
  "multicolor": "spinner-module-scss-module__--vZkW__multicolor",
  "spin": "spinner-module-scss-module__--vZkW__spin",
  "spinner": "spinner-module-scss-module__--vZkW__spinner",
  "spinner-large": "spinner-module-scss-module__--vZkW__spinner-large",
  "spinner-medium": "spinner-module-scss-module__--vZkW__spinner-medium",
  "spinner-small": "spinner-module-scss-module__--vZkW__spinner-small",
});
